import { useSelector } from 'react-redux';

const useIntentFieldResolver = () => {
  const tagsById = useSelector((state) => state.Tags.byId);
  const companiesById = useSelector((state) => state.Companies.byId);
  const projectsById = useSelector((state) => state.Projects.byId);
  const accountsById = useSelector((state) => state.Account.byId);

  const resolveFieldValue = (field, value) => {
    if (value == null) return null;
    const resolvers = {
      project: (v) => projectsById[v]?.title ? `#${v} ${projectsById[v].title}` : `#${v}`,
      tag: (v) => tagsById[v]?.title ? `#${v} ${tagsById[v].title}` : `#${v}`,
      company: (v) => companiesById[v]?.title ? `#${v} ${companiesById[v].title}` : `#${v}`,
      account: (v) => accountsById[v]?.title ? `#${v} ${accountsById[v].title}` : `#${v}`,
    };
    return resolvers[field]?.(value) ?? value;
  };

  return { resolveFieldValue };
};

export default useIntentFieldResolver;
